import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "80px 16px 60px",
        background:
          "linear-gradient(135deg, rgba(21,83,130,0.95), rgba(5,25,45,0.95))",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        fontFamily: "Poppins, Arial, sans-serif",
      }}
    >
      {/* Card */}
      <div
        style={{
          width: "100%",
          maxWidth: "1000px",
          backgroundColor: "rgba(255,255,255,0.98)",
          borderRadius: "18px",
          boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
          padding: "32px 24px 36px",
        }}
      >
        {/* Header */}
        <div
          style={{
            borderBottom: "2px solid rgba(21,83,130,0.1)",
            paddingBottom: "14px",
            marginBottom: "24px",
          }}
        >
          <h1
            style={{
              fontSize: "30px",
              margin: 0,
              color: "#155382",
              letterSpacing: "0.5px",
            }}
          >
            Privacy Policy
          </h1>
          <p
            style={{
              margin: "8px 0 0",
              fontSize: "13px",
              color: "#666",
            }}
          >
            Technocrat Aerospace and Defence Pvt. Ltd. (TAAD)
          </p>
        </div>

        {/* Section: Intro */}
        <p
          style={{
            lineHeight: 1.8,
            fontSize: "14px",
            color: "#333",
            marginBottom: "18px",
          }}
        >
          At Technocrat Aerospace and Defence Pvt. Ltd. (“TAAD”, “we”, “our” or
          “us”), we are committed to protecting your personal information and
          respecting your privacy. This Privacy Policy explains how we collect,
          use, store and safeguard your data when you visit our website, contact
          us, or engage with our services.
        </p>

        {/* Reusable section style */}
        <Section
          title="1. Information We Collect"
          items={[
            "Contact details such as name, email address, phone number, company name and designation that you share through forms, emails or calls.",
            "Technical information such as IP address, browser type, device information and pages visited (through standard analytics tools).",
            "Any additional information you voluntarily provide in enquiries, career applications or during business communication.",
          ]}
        />

        <Section
          title="2. How We Use Your Information"
          items={[
            "To respond to your enquiries, provide quotations, proposals and product or service information.",
            "To process job applications and communicate regarding career opportunities.",
            "To improve our website, services and user experience based on general usage trends.",
            "To send important updates, technical information or notices related to our products and services (no spam).",
          ]}
        />

        <Section
          title="3. Data Protection & Sharing"
          items={[
            "We do not sell, rent or trade your personal information to third parties.",
            "Access to your information is restricted to authorised personnel, partners or service providers who require it for legitimate business purposes and are bound by confidentiality obligations.",
            "We use reasonable technical and organisational safeguards to protect your data against unauthorised access, alteration, disclosure or destruction.",
          ]}
        />

        <Section
          title="4. Cookies & Analytics"
          items={[
            "Our website may use cookies and analytics tools to understand visitor behaviour and improve performance.",
            "These tools typically collect anonymised or aggregated information and do not identify you personally.",
            "You can manage or disable cookies through your browser settings; however, some website features may not function correctly if cookies are disabled.",
          ]}
        />

<Section
  title="5. Copyright & Content Usage"
  items={[
    "All text, graphics, images, logos, icons, documents and other content on this website are the intellectual property of Technocrat Aerospace and Defence Pvt. Ltd., unless otherwise stated.",
    "Unauthorised copying, reproduction, distribution, modification or republication of any content, in whole or in part, in any form, without our prior written permission is strictly prohibited.",
    "Use of our name, logo or branding in any manner that may cause confusion or misrepresent association is not permitted.",
    <span>
      Website completely developed and maintained by **LAVISH**, and any portion of the
      source code, design or written material cannot be reused or reproduced without
      explicit consent from  Technocrat Aerospace and Defence Private Limited.
    </span>,
  ]}
/>

        <Section
          title="6. Third-Party Links"
          items={[
            "Our website may contain links to external websites (e.g., social media platforms, partner organisations, resources).",
            "These third-party sites are not operated or controlled by us, and we are not responsible for their content, security or privacy practices.",
            "We encourage you to review the privacy policies of any third-party sites you visit.",
          ]}
        />

        <Section
          title="7. Your Rights"
          items={[
            "You may contact us to review, update or request deletion of the personal information you have shared with us, subject to applicable laws and our legitimate business or legal obligations.",
            "You may opt out of receiving non-essential marketing or communication emails from us at any time by writing to us.",
          ]}
        />

        <Section
          title="8. Changes to This Policy"
          items={[
            "We may update this Privacy Policy from time to time to reflect changes in legal, regulatory, or operational requirements.",
            "The updated version will always be available on this page with a revised effective date.",
          ]}
        />

        {/* Contact section */}
        <div style={{ marginTop: "28px" }}>
          <h2
            style={{
              fontSize: "18px",
              color: "#155382",
              marginBottom: "8px",
            }}
          >
            9. Contact Us
          </h2>
          <p
            style={{
              lineHeight: 1.8,
              fontSize: "14px",
              color: "#333",
              marginBottom: "6px",
            }}
          >
            If you have any questions, concerns or requests regarding this
            Privacy Policy or your personal data, please contact us at:
          </p>
          <p
            style={{
              lineHeight: 1.8,
              fontSize: "14px",
              color: "#333",
            }}
          >
            <b>Email:</b> info@taadpl.com / sales@taadpl.com
            <br />
            <b>Corporate Address:</b> 11B, 9th Floor, Urbtech NPX, Sector 153,
            Noida, U.P. 201310
            <br />
            <b>Registered Address:</b> 419, Eldeco Udyan-1, Behind Bangla
            Bazar, Lucknow 226002
          </p>
          <p
            style={{
              marginTop: "12px",
              fontSize: "12px",
              color: "#777",
            }}
          >
            <i>Effective Date: 01 January 2025</i>
          </p>
        </div>
      </div>
    </div>
  );
}

/**
 * Small helper component for sections
 */
function Section({ title, items }) {
  return (
    <div style={{ marginBottom: "18px" }}>
      <h2
        style={{
          fontSize: "18px",
          color: "#155382",
          marginBottom: "6px",
        }}
      >
        {title}
      </h2>
      <ul
        style={{
          margin: 0,
          paddingLeft: "18px",
          lineHeight: 1.8,
          fontSize: "14px",
          color: "#333",
        }}
      >
        {items.map((text, i) => (
          <li key={i} style={{ marginBottom: "4px" }}>
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
}
